import script from "./scrolling-color-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./scrolling-color-picker.vue?vue&type=script&setup=true&lang=ts"

import "./scrolling-color-picker.vue?vue&type=style&index=0&id=469d7960&lang=scss"

const __exports__ = script;

export default __exports__